import { useQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { AuthHelper } from "../helpers/auth.helper";

import { ISettingsOverview } from "../types/services.interfaces/settings-cax";

export const useGetSettingsOverview = () => {
    AuthHelper.presetPrivateRequest(api);

    const queryFn = async (): Promise<ISettingsOverview> => {
        const res = await api.get('/settings-cax/overview');
        return res.data;
    };

    return useQuery({
        queryKey: ['settings-overview'],
        queryFn,
        retry: false,
        enabled: AuthHelper.isAuthTokenValid().result,
    });
};
